// import React, { useState } from 'react';
// import { ChevronLeft, ChevronRight, Smartphone, Monitor, QrCode } from 'lucide-react';

// const MilesDetail = () => {
//   const [currentAdIndex, setCurrentAdIndex] = useState(1);
//   const [viewMode, setViewMode] = useState('desktop'); // 'mobile' or 'desktop'

//   const adFormats = [
//     {
//       id: 1,
//       name: '2025_05_TurkishAirlines_...',
//       dimension: '300x250',
//       type: 'Banner - Javascript tag',
//       creativeId: '1552639',
//       selected: false
//     },
//     {
//       id: 2,
//       name: '2025_05_TurkishAirlines_...',
//       dimension: '300x600',
//       type: 'Banner - Javascript tag',
//       creativeId: '1552640',
//       selected: true
//     },
//     {
//       id: 3,
//       name: '2025_05_TurkishAirlines_...',
//       dimension: '320x480',
//       type: 'Banner - Javascript tag',
//       creativeId: '1552641',
//       selected: false
//     }
//   ];

//   const currentAd = adFormats.find(ad => ad.selected) || adFormats[1];

//   const nextAd = () => {
//     setCurrentAdIndex(prev => (prev < adFormats.length ? prev + 1 : 1));
//   };

//   const prevAd = () => {
//     setCurrentAdIndex(prev => (prev > 1 ? prev - 1 : adFormats.length));
//   };

//   const AdContent = () => (
//     <div className="relative">
//       {currentAd.dimension === '300x250' && (
//         <div className="w-full max-w-[300px] mx-auto">
//           <div className="bg-gradient-to-br from-red-500 to-orange-600 text-white p-4 rounded-lg shadow-lg">
//             <div className="text-sm font-semibold mb-2">Black kartını 50% endirimle şifariş edin!</div>
//             <div className="flex items-center justify-between">
//               <div className="bg-white text-red-500 px-3 py-1 rounded-full text-xs font-bold">50%</div>
//               <div className="text-xs">İçi Mıqnatıs</div>
//             </div>
//             <div className="mt-2 text-xs">WhatsApp sifarişi</div>
//             <div className="absolute top-2 right-2 w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
//               <div className="w-4 h-4 bg-white rounded-full"></div>
//             </div>
//           </div>
//         </div>
//       )}
      
//       {currentAd.dimension === '300x600' && (
//         <div className="w-full max-w-[300px] mx-auto">
//           <div className="bg-gradient-to-b from-cyan-400 to-blue-600 rounded-lg overflow-hidden shadow-lg" style={{aspectRatio: '300/600'}}>
//             <div className="relative h-full">
//               <div className="absolute inset-0 bg-gradient-to-b from-sky-300 to-blue-400"></div>
//               <div className="relative h-full flex flex-col">
//                 <div className="flex-1 flex items-center justify-center">
//                   <div className="w-16 h-8 bg-white/30 rounded-full flex items-center justify-center">
//                     <div className="w-8 h-4 bg-white/50 rounded-full"></div>
//                   </div>
//                 </div>
//                 <div className="h-1/3 bg-gradient-to-r from-yellow-200 to-orange-200 relative">
//                   <div className="absolute inset-0 bg-gradient-to-t from-orange-300/50 to-transparent"></div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
      
//       {currentAd.dimension === '320x480' && (
//         <div className="w-full max-w-[320px] mx-auto">
//           <div className="bg-gradient-to-br from-purple-500 to-pink-600 text-white p-6 rounded-lg shadow-lg" style={{aspectRatio: '320/480'}}>
//             <div className="h-full flex flex-col justify-between">
//               <div>
//                 <h3 className="text-lg font-bold mb-2">Turkish Airlines</h3>
//                 <p className="text-sm opacity-90">Discover the world with us</p>
//               </div>
//               <div className="text-center">
//                 <div className="bg-white text-purple-600 px-6 py-2 rounded-full font-semibold">
//                   Book Now
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );

//   return (
//     <div className="min-h-screen bg-gray-50 flex mt-14">
//       {/* Left Sidebar */}
//       <div className="w-64 bg-white border-r border-gray-200 p-4 hidden lg:block">
//         <div className="mb-6">
//           <h2 className="text-lg font-semibold text-gray-800 mb-2">2025_05_Turkis...</h2>
//           <p className="text-sm text-blue-500 mb-1">ID: 238362</p>
//           <button className="text-sm text-blue-500 hover:underline">Switch to previous version</button>
//         </div>

//         <div className="mb-6">
//           <button className="text-sm text-blue-500 hover:underline">All creatives preview</button>
//         </div>

//         <div className="space-y-2">
//           {adFormats.map((ad) => (
//             <div 
//               key={ad.id}
//               className={`p-3 rounded-lg border cursor-pointer transition-colors ${
//                 ad.selected 
//                   ? 'bg-blue-100 border-blue-300' 
//                   : 'bg-gray-50 border-gray-200 hover:bg-gray-100'
//               }`}
//             >
//               <div className="text-sm font-medium text-gray-800 mb-1 truncate">
//                 {ad.name}
//               </div>
//               <div className="text-xs text-blue-500 mb-1">
//                 Ad dimension: {ad.dimension}
//               </div>
//               <div className="text-xs text-gray-600">
//                 Ad type: {ad.type}
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Main Content */}
//       <div className="flex-1 flex flex-col">
//         {/* Header */}
//         <div className="bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
//           <div className="flex items-center space-x-4">
//             <h1 className="text-xl font-semibold text-gray-800 truncate">
//               2025_05_TurkishAirlines_RM_FP_Standard_300...
//             </h1>
//             <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
//           </div>
          
//           <div className="flex items-center space-x-4">
//             <div className="flex items-center bg-gray-100 rounded-lg p-1">
//               <button
//                 onClick={() => setViewMode('mobile')}
//                 className={`flex items-center space-x-2 px-3 py-2 rounded-md text-sm transition-colors ${
//                   viewMode === 'mobile' 
//                     ? 'bg-purple-600 text-white' 
//                     : 'text-gray-600 hover:bg-gray-200'
//                 }`}
//               >
//                 <Smartphone size={16} />
//                 <span>Mobile</span>
//               </button>
//               <button
//                 onClick={() => setViewMode('desktop')}
//                 className={`flex items-center space-x-2 px-3 py-2 rounded-md text-sm transition-colors ${
//                   viewMode === 'desktop' 
//                     ? 'bg-gray-800 text-white' 
//                     : 'text-gray-600 hover:bg-gray-200'
//                 }`}
//               >
//                 <Monitor size={16} />
//                 <span>Desktop</span>
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Content Area */}
//         <div className="flex-1 flex">
//           {/* Ad Preview */}
//           <div className="flex-1 p-6">
//             <div className="flex items-center justify-center space-x-4 mb-6">
//               <button 
//                 onClick={prevAd}
//                 className="flex items-center space-x-2 text-gray-500 hover:text-gray-700"
//               >
//                 <ChevronLeft size={20} />
//                 <span>Prev Ad</span>
//               </button>
              
//               <button 
//                 onClick={nextAd}
//                 className="flex items-center space-x-2 text-gray-500 hover:text-gray-700"
//               >
//                 <span>Next Ad</span>
//                 <ChevronRight size={20} />
//               </button>
//             </div>

//             {/* Ad Container */}
//             <div className={`mx-auto ${viewMode === 'mobile' ? 'max-w-sm' : 'max-w-4xl'}`}>
//               <div className={`bg-white rounded-xl shadow-lg p-8 ${
//                 viewMode === 'mobile' 
//                   ? 'mx-4' 
//                   : ''
//               }`}>
//                 {/* Mock website layout */}
//                 <div className="space-y-4 mb-8">
//                   {Array.from({ length: viewMode === 'mobile' ? 3 : 4 }).map((_, i) => (
//                     <div key={i} className="flex space-x-4">
//                       <div className="w-16 h-16 bg-gray-200 rounded-lg flex-shrink-0"></div>
//                       <div className="flex-1 space-y-2">
//                         <div className="h-4 bg-gray-200 rounded w-3/4"></div>
//                         <div className="h-3 bg-gray-100 rounded w-1/2"></div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>

//                 {/* Ad Placement */}
//                 <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 bg-gray-50">
//                   <AdContent />
//                 </div>

//                 {/* More mock content */}
//                 <div className="space-y-4 mt-8">
//                   {Array.from({ length: viewMode === 'mobile' ? 2 : 3 }).map((_, i) => (
//                     <div key={i} className="h-4 bg-gray-200 rounded w-full"></div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Right Sidebar */}
//           <div className="w-80 bg-white border-l border-gray-200 p-6 hidden xl:block">
//             <h3 className="text-lg font-semibold text-gray-800 mb-6">Creative Details</h3>
            
//             <div className="space-y-6">
//               <div className="bg-purple-50 rounded-lg p-4">
//                 <h4 className="font-medium text-purple-800 mb-3">Ad Info</h4>
//                 <div className="space-y-2 text-sm">
//                   <div>
//                     <span className="font-medium text-gray-700">Ad Dimension:</span>
//                     <div className="text-gray-600">{currentAd.dimension}</div>
//                   </div>
//                   <div>
//                     <span className="font-medium text-gray-700">Ad Type:</span>
//                     <div className="text-gray-600">{currentAd.type}</div>
//                   </div>
//                   <div>
//                     <span className="font-medium text-gray-700">Creative ID:</span>
//                     <div className="text-gray-600">{currentAd.creativeId}</div>
//                   </div>
//                 </div>
//                 <button className="text-blue-500 text-sm hover:underline mt-3">
//                   Open Full-Size Creative
//                 </button>
//               </div>

//               <div className="flex justify-center">
//                 <div className="w-32 h-32 border border-gray-300 rounded-lg flex items-center justify-center bg-white">
//                   <QrCode size={80} className="text-gray-400" />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Mobile Menu Button (shown on mobile) */}
//       <div className="lg:hidden fixed bottom-4 right-4">
//         <button className="bg-blue-600 text-white p-3 rounded-full shadow-lg">
//           <Monitor size={24} />
//         </button>
//       </div>
//     </div>
//   );
// };

// export default MilesDetail;
// import React, { useState } from 'react';
// import { ChevronLeft, ChevronRight, Smartphone, Monitor, QrCode } from 'lucide-react';

// const MilesDetail = () => {
//   const [selectedAdId, setSelectedAdId] = useState(2);
//   const [viewMode, setViewMode] = useState('desktop'); // 'mobile' or 'desktop'

//   const adFormats = [
//     {
//       id: 1,
//       name: '2025_05_TurkishAirlines_...',
//       dimension: '300x250',
//       type: 'Banner - Javascript tag',
//       creativeId: '1552639'
//     },
//     {
//       id: 2,
//       name: '2025_05_TurkishAirlines_...',
//       dimension: '300x600',
//       type: 'Banner - Javascript tag',
//       creativeId: '1552640'
//     },
//     {
//       id: 3,
//       name: '2025_05_TurkishAirlines_...',
//       dimension: '320x480',
//       type: 'Banner - Javascript tag',
//       creativeId: '1552641'
//     }
//   ];

//   const currentAd = adFormats.find(ad => ad.id === selectedAdId) || adFormats[1];

//   const selectAd = (adId) => {
//     setSelectedAdId(adId);
//   };

//   const nextAd = () => {
//     const currentIndex = adFormats.findIndex(ad => ad.id === selectedAdId);
//     const nextIndex = currentIndex === adFormats.length - 1 ? 0 : currentIndex + 1;
//     setSelectedAdId(adFormats[nextIndex].id);
//   };

//   const prevAd = () => {
//     const currentIndex = adFormats.findIndex(ad => ad.id === selectedAdId);
//     const prevIndex = currentIndex === 0 ? adFormats.length - 1 : currentIndex - 1;
//     setSelectedAdId(adFormats[prevIndex].id);
//   };

//   const AdContent = () => (
//     <div className="relative">
//       {currentAd.dimension === '300x250' && (
//         <div className="w-full max-w-[300px] mx-auto">
//           <div className="bg-gradient-to-br from-red-500 to-orange-600 text-white p-4 rounded-lg shadow-lg relative overflow-hidden">
//             <div className="absolute inset-0 bg-black/10"></div>
//             <div className="relative">
//               <div className="text-sm font-semibold mb-2 text-green-300">Black kartını 50% endirimle şifariş edin!</div>
//               <div className="flex items-center justify-between mb-3">
//                 <div className="bg-white text-red-500 px-3 py-1 rounded-full text-xs font-bold shadow-md">50%</div>
//                 <div className="text-xs bg-red-600 px-2 py-1 rounded">20 TL VƏ YUXARI</div>
//               </div>
//               <div className="flex items-center space-x-2">
//                 <div className="w-8 h-8 bg-white/20 rounded border border-white/30"></div>
//                 <div className="text-xs font-medium">İçi sifarişi ədin</div>
//               </div>
//               <div className="absolute -top-2 -right-2 w-12 h-12">
//                 <div className="w-full h-full bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full opacity-80"></div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
      
//       {currentAd.dimension === '300x600' && (
//         <div className="w-full max-w-[300px] mx-auto">
//           <div className="bg-gradient-to-b from-cyan-300 via-sky-400 to-blue-500 rounded-lg overflow-hidden shadow-lg" style={{aspectRatio: '300/600'}}>
//             <div className="relative h-full">
//               {/* Sky section */}
//               <div className="h-3/5 relative bg-gradient-to-b from-cyan-200 to-sky-400">
//                 <div className="absolute top-1/3 left-1/2 transform -translate-x-1/2">
//                   <div className="w-16 h-8 bg-white/40 rounded-full flex items-center justify-center shadow-lg">
//                     <div className="w-8 h-4 bg-gray-600 rounded-full"></div>
//                   </div>
//                 </div>
//                 {/* Clouds */}
//                 <div className="absolute top-1/4 left-1/4 w-8 h-4 bg-white/30 rounded-full"></div>
//                 <div className="absolute top-1/5 right-1/4 w-6 h-3 bg-white/25 rounded-full"></div>
//               </div>
//               {/* Beach/Ground section */}
//               <div className="h-2/5 bg-gradient-to-b from-yellow-200 via-orange-200 to-orange-300 relative">
//                 <div className="absolute inset-0 bg-gradient-to-t from-orange-400/50 to-transparent"></div>
//                 <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-orange-500/30 to-transparent"></div>
//                 {/* Waves pattern */}
//                 <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-r from-transparent via-white/20 to-transparent"></div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
      
//       {currentAd.dimension === '320x480' && (
//         <div className="w-full max-w-[320px] mx-auto">
//           <div className="bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-600 text-white p-6 rounded-lg shadow-lg relative overflow-hidden" style={{aspectRatio: '320/480'}}>
//             <div className="absolute inset-0 bg-gradient-to-br from-transparent to-black/20"></div>
//             <div className="relative h-full flex flex-col justify-between">
//               <div>
//                 <div className="w-12 h-12 bg-white/20 rounded-full mb-4 flex items-center justify-center">
//                   <div className="w-8 h-8 bg-white/40 rounded-full"></div>
//                 </div>
//                 <h3 className="text-xl font-bold mb-2">Turkish Airlines</h3>
//                 <p className="text-sm opacity-90 mb-4">Widen your world</p>
//                 <div className="text-xs opacity-75">
//                   Discover amazing destinations with special offers
//                 </div>
//               </div>
//               <div className="text-center">
//                 <div className="bg-white text-purple-600 px-8 py-3 rounded-full font-semibold text-sm shadow-lg hover:shadow-xl transition-shadow">
//                   Book Now
//                 </div>
//               </div>
//             </div>
//             {/* Decorative elements */}
//             <div className="absolute top-4 right-4 w-16 h-16 bg-white/10 rounded-full"></div>
//             <div className="absolute bottom-20 left-4 w-8 h-8 bg-white/5 rounded-full"></div>
//           </div>
//         </div>
//       )}
//     </div>
//   );

//   return (
//     <div className="min-h-screen bg-gray-50 flex mt-20">
//       {/* Left Sidebar */}
//       <div className="w-64 bg-white border-r border-gray-200 p-4 hidden lg:block">
//         <div className="mb-6">
//           <h2 className="text-lg font-semibold text-gray-800 mb-2">2025_05_Turkis...</h2>
//           <p className="text-sm text-blue-500 mb-1">ID: 238362</p>
//           <button className="text-sm text-blue-500 hover:underline">Switch to previous version</button>
//         </div>

//         <div className="mb-6">
//           <button className="text-sm text-blue-500 hover:underline">All creatives preview</button>
//         </div>

//         <div className="space-y-2">
//           {adFormats.map((ad) => (
//             <div 
//               key={ad.id}
//               onClick={() => selectAd(ad.id)}
//               className={`p-3 rounded-lg border cursor-pointer transition-all duration-200 hover:shadow-md ${
//                 ad.id === selectedAdId
//                   ? 'bg-blue-100 border-blue-300 shadow-sm' 
//                   : 'bg-gray-50 border-gray-200 hover:bg-gray-100 hover:border-gray-300'
//               }`}
//             >
//               <div className="text-sm font-medium text-gray-800 mb-2 truncate">
//                 {ad.name}
//               </div>
              
//               {/* Ad Preview Thumbnail */}
//               <div className="mb-3 flex justify-center">
//                 {ad.dimension === '300x250' && (
//                   <div className="w-20 h-16 bg-gradient-to-br from-red-400 to-orange-500 rounded border shadow-sm flex items-center justify-center">
//                     <div className="text-xs text-white font-bold">50%</div>
//                   </div>
//                 )}
//                 {ad.dimension === '300x600' && (
//                   <div className="w-12 h-24 bg-gradient-to-b from-cyan-300 to-blue-400 rounded border shadow-sm relative overflow-hidden">
//                     <div className="absolute top-1/3 left-1/2 transform -translate-x-1/2 w-3 h-1.5 bg-white/40 rounded-full"></div>
//                     <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-orange-200 to-transparent"></div>
//                   </div>
//                 )}
//                 {ad.dimension === '320x480' && (
//                   <div className="w-16 h-20 bg-gradient-to-br from-purple-500 to-pink-500 rounded border shadow-sm flex items-center justify-center">
//                     <div className="text-xs text-white font-bold">TK</div>
//                   </div>
//                 )}
//               </div>
              
//               <div className="space-y-1">
//                 <div className="text-xs text-blue-500">
//                   <span className="font-medium">Ad dimension:</span> {ad.dimension}
//                 </div>
//                 <div className="text-xs text-gray-600">
//                   <span className="font-medium">Ad type:</span> {ad.type}
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Main Content */}
//       <div className="flex-1 flex flex-col">
//         {/* Header */}
//         <div className="bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
//           <div className="flex items-center space-x-4">
//             <h1 className="text-xl font-semibold text-gray-800 truncate">
//               2025_05_TurkishAirlines_RM_FP_Standard_300...
//             </h1>
//             <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
//           </div>
          
//           <div className="flex items-center space-x-4">
//             <div className="flex items-center bg-gray-100 rounded-lg p-1">
//               <button
//                 onClick={() => setViewMode('mobile')}
//                 className={`flex items-center space-x-2 px-3 py-2 rounded-md text-sm transition-colors ${
//                   viewMode === 'mobile' 
//                     ? 'bg-purple-600 text-white' 
//                     : 'text-gray-600 hover:bg-gray-200'
//                 }`}
//               >
//                 <Smartphone size={16} />
//                 <span>Mobile</span>
//               </button>
//               <button
//                 onClick={() => setViewMode('desktop')}
//                 className={`flex items-center space-x-2 px-3 py-2 rounded-md text-sm transition-colors ${
//                   viewMode === 'desktop' 
//                     ? 'bg-gray-800 text-white' 
//                     : 'text-gray-600 hover:bg-gray-200'
//                 }`}
//               >
//                 <Monitor size={16} />
//                 <span>Desktop</span>
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Content Area */}
//         <div className="flex-1 flex">
//           {/* Ad Preview */}
//           <div className="flex-1 p-6">
//             <div className="flex items-center justify-center space-x-4 mb-6">
//               <button 
//                 onClick={prevAd}
//                 className="flex items-center space-x-2 text-gray-500 hover:text-gray-700"
//               >
//                 <ChevronLeft size={20} />
//                 <span>Prev Ad</span>
//               </button>
              
//               <button 
//                 onClick={nextAd}
//                 className="flex items-center space-x-2 text-gray-500 hover:text-gray-700"
//               >
//                 <span>Next Ad</span>
//                 <ChevronRight size={20} />
//               </button>
//             </div>

//             {/* Ad Container */}
//             <div className={`mx-auto ${viewMode === 'mobile' ? 'max-w-sm' : 'max-w-4xl'}`}>
//               <div className={`bg-white rounded-xl shadow-lg p-8 ${
//                 viewMode === 'mobile' 
//                   ? 'mx-4' 
//                   : ''
//               }`}>
//                 {/* Mock website layout */}
//                 {/* <div className="space-y-4 mb-8">
//                   {Array.from({ length: viewMode === 'mobile' ? 3 : 4 }).map((_, i) => (
//                     <div key={i} className="flex space-x-4">
//                       <div className="w-16 h-16 bg-gray-200 rounded-lg flex-shrink-0"></div>
//                       <div className="flex-1 space-y-2">
//                         <div className="h-4 bg-gray-200 rounded w-3/4"></div>
//                         <div className="h-3 bg-gray-100 rounded w-1/2"></div>
//                       </div>
//                     </div>
//                   ))}
//                 </div> */}

//                 {/* Ad Placement */}
//                 <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 bg-gray-50">
//                   <AdContent />
//                 </div>

//                 {/* More mock content */}
//                 <div className="space-y-4 mt-8">
//                   {Array.from({ length: viewMode === 'mobile' ? 2 : 3 }).map((_, i) => (
//                     <div key={i} className="h-4 bg-gray-200 rounded w-full"></div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Right Sidebar */}
//           <div className="w-80 bg-white border-l border-gray-200 p-6 hidden xl:block">
//             <h3 className="text-lg font-semibold text-gray-800 mb-6">Creative Details</h3>
            
//             <div className="space-y-6">
//               <div className="bg-purple-50 rounded-lg p-4">
//                 <h4 className="font-medium text-purple-800 mb-3">Ad Info</h4>
//                 <div className="space-y-2 text-sm">
//                   <div>
//                     <span className="font-medium text-gray-700">Ad Dimension:</span>
//                     <div className="text-gray-600">{currentAd.dimension}</div>
//                   </div>
//                   <div>
//                     <span className="font-medium text-gray-700">Ad Type:</span>
//                     <div className="text-gray-600">{currentAd.type}</div>
//                   </div>
//                   <div>
//                     <span className="font-medium text-gray-700">Creative ID:</span>
//                     <div className="text-gray-600">{currentAd.creativeId}</div>
//                   </div>
//                 </div>
//                 <button className="text-blue-500 text-sm hover:underline mt-3">
//                   Open Full-Size Creative
//                 </button>
//               </div>

//               <div className="flex justify-center">
//                 <div className="w-32 h-32 border border-gray-300 rounded-lg flex items-center justify-center bg-white">
//                   <QrCode size={80} className="text-gray-400" />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Mobile Menu Button (shown on mobile) */}
//       <div className="lg:hidden fixed bottom-4 right-4">
//         <button className="bg-blue-600 text-white p-3 rounded-full shadow-lg">
//           <Monitor size={24} />
//         </button>
//       </div>
//     </div>
//   );
// };

// export default MilesDetail;


import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Smartphone, Monitor, QrCode } from 'lucide-react';

const MilesDetail = () => {
  const [selectedAdId, setSelectedAdId] = useState(2);
  const [viewMode, setViewMode] = useState('desktop'); // 'mobile' or 'desktop'

  const adFormats = [
    {
      id: 1,
      name: '2025_05_TurkishAirlines_...',
      dimension: '300x250',
      type: 'Banner - Javascript tag',
      creativeId: '1552639'
    },
    {
      id: 2,
      name: '2025_05_TurkishAirlines_...',
      dimension: '300x600',
      type: 'Banner - Javascript tag',
      creativeId: '1552640'
    },
    {
      id: 3,
      name: '2025_05_TurkishAirlines_...',
      dimension: '320x480',
      type: 'Banner - Javascript tag',
      creativeId: '1552641'
    }
  ];

  const currentAd = adFormats.find(ad => ad.id === selectedAdId) || adFormats[1];

  const selectAd = (adId) => {
    setSelectedAdId(adId);
  };

  const nextAd = () => {
    const currentIndex = adFormats.findIndex(ad => ad.id === selectedAdId);
    const nextIndex = currentIndex === adFormats.length - 1 ? 0 : currentIndex + 1;
    setSelectedAdId(adFormats[nextIndex].id);
  };

  const prevAd = () => {
    const currentIndex = adFormats.findIndex(ad => ad.id === selectedAdId);
    const prevIndex = currentIndex === 0 ? adFormats.length - 1 : currentIndex - 1;
    setSelectedAdId(adFormats[prevIndex].id);
  };

  const AdContent = () => (
    <div className="relative">
      {currentAd.dimension === '300x250' && (
        <div className="w-full max-w-[300px] mx-auto">
          <div className="bg-gradient-to-br from-red-500 to-orange-600 text-white p-4 rounded-lg shadow-lg relative overflow-hidden">
            <div className="absolute inset-0 bg-black/10"></div>
            <div className="relative">
              <div className="text-sm font-semibold mb-2 text-green-300">Black kartını 50% endirimle şifariş edin!</div>
              <div className="flex items-center justify-between mb-3">
                <div className="bg-white text-red-500 px-3 py-1 rounded-full text-xs font-bold shadow-md">50%</div>
                <div className="text-xs bg-red-600 px-2 py-1 rounded">20 TL VƏ YUXARI</div>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-8 h-8 bg-white/20 rounded border border-white/30"></div>
                <div className="text-xs font-medium">İçi sifarişi ədin</div>
              </div>
              <div className="absolute -top-2 -right-2 w-12 h-12">
                <div className="w-full h-full bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full opacity-80"></div>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {currentAd.dimension === '300x600' && (
        <div className="w-full max-w-[300px] mx-auto">
          <div className="bg-gradient-to-b from-cyan-300 via-sky-400 to-blue-500 rounded-lg overflow-hidden shadow-lg" style={{aspectRatio: '300/600'}}>
            <div className="relative h-full">
              {/* Sky section */}
              <div className="h-3/5 relative bg-gradient-to-b from-cyan-200 to-sky-400">
                <div className="absolute top-1/3 left-1/2 transform -translate-x-1/2">
                  <div className="w-16 h-8 bg-white/40 rounded-full flex items-center justify-center shadow-lg">
                    <div className="w-8 h-4 bg-gray-600 rounded-full"></div>
                  </div>
                </div>
                {/* Clouds */}
                <div className="absolute top-1/4 left-1/4 w-8 h-4 bg-white/30 rounded-full"></div>
                <div className="absolute top-1/5 right-1/4 w-6 h-3 bg-white/25 rounded-full"></div>
              </div>
              {/* Beach/Ground section */}
              <div className="h-2/5 bg-gradient-to-b from-yellow-200 via-orange-200 to-orange-300 relative">
                <div className="absolute inset-0 bg-gradient-to-t from-orange-400/50 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-orange-500/30 to-transparent"></div>
                {/* Waves pattern */}
                <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-r from-transparent via-white/20 to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {currentAd.dimension === '320x480' && (
        <div className="w-full max-w-[320px] mx-auto">
          <div className="bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-600 text-white p-6 rounded-lg shadow-lg relative overflow-hidden" style={{aspectRatio: '320/480'}}>
            <div className="absolute inset-0 bg-gradient-to-br from-transparent to-black/20"></div>
            <div className="relative h-full flex flex-col justify-between">
              <div>
                <div className="w-12 h-12 bg-white/20 rounded-full mb-4 flex items-center justify-center">
                  <div className="w-8 h-8 bg-white/40 rounded-full"></div>
                </div>
                <h3 className="text-xl font-bold mb-2">Turkish Airlines</h3>
                <p className="text-sm opacity-90 mb-4">Widen your world</p>
                <div className="text-xs opacity-75">
                  Discover amazing destinations with special offers
                </div>
              </div>
              <div className="text-center">
                <div className="bg-white text-purple-600 px-8 py-3 rounded-full font-semibold text-sm shadow-lg hover:shadow-xl transition-shadow">
                  Book Now
                </div>
              </div>
            </div>
            {/* Decorative elements */}
            <div className="absolute top-4 right-4 w-16 h-16 bg-white/10 rounded-full"></div>
            <div className="absolute bottom-20 left-4 w-8 h-8 bg-white/5 rounded-full"></div>
          </div>
        </div>
      )}
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50 flex mt-12">
      {/* Left Sidebar */}
      <div className="w-64 bg-white border-r border-gray-200 p-4 hidden lg:block">
        <div className="mb-6">
          <h2 className="text-lg font-semibold text-gray-800 mb-2">2025_05_Turkis...</h2>
          {/* <p className="text-sm text-blue-500 mb-1">ID: 238362</p>
          <button className="text-sm text-blue-500 hover:underline">Switch to previous version</button> */}
        </div>

        <div className="mb-6">
          <button className="text-sm text-blue-500 hover:underline">All creatives preview</button>
        </div>

        <div className="space-y-2">
          {adFormats.map((ad) => (
            <div 
              key={ad.id}
              onClick={() => selectAd(ad.id)}
              className={`p-3 rounded-lg border cursor-pointer transition-all duration-200 hover:shadow-md ${
                ad.id === selectedAdId
                  ? 'bg-blue-100 border-blue-300 shadow-sm' 
                  : 'bg-gray-50 border-gray-200 hover:bg-gray-100 hover:border-gray-300'
              }`}
            >
              <div className="text-sm font-medium text-gray-800 mb-2 truncate">
                {ad.name}
              </div>
              
              {/* Ad Preview Thumbnail */}
              <div className="mb-3 flex justify-center">
                {ad.dimension === '300x250' && (
                  <div className="w-20 h-16 bg-gradient-to-br from-red-400 to-orange-500 rounded border shadow-sm flex items-center justify-center">
                    <div className="text-xs text-white font-bold">50%</div>
                  </div>
                )}
                {ad.dimension === '300x600' && (
                  <div className="w-12 h-24 bg-gradient-to-b from-cyan-300 to-blue-400 rounded border shadow-sm relative overflow-hidden">
                    <div className="absolute top-1/3 left-1/2 transform -translate-x-1/2 w-3 h-1.5 bg-white/40 rounded-full"></div>
                    <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-orange-200 to-transparent"></div>
                  </div>
                )}
                {ad.dimension === '320x480' && (
                  <div className="w-16 h-20 bg-gradient-to-br from-purple-500 to-pink-500 rounded border shadow-sm flex items-center justify-center">
                    <div className="text-xs text-white font-bold">TK</div>
                  </div>
                )}
              </div>
              
              <div className="space-y-1">
                <div className="text-xs text-blue-500">
                  <span className="font-medium">Ad dimension:</span> {ad.dimension}
                </div>
                <div className="text-xs text-gray-600">
                  <span className="font-medium">Ad type:</span> {ad.type}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        {/* Header */}
        <div className="bg-white border-b border-gray-200 px-4 lg:px-6 py-4 flex items-center justify-between">
          <div className="flex items-center space-x-2 lg:space-x-4">
            <h1 className="text-lg lg:text-xl font-semibold text-gray-800 truncate">
              <span className="hidden sm:inline">2025_05_TurkishAirlines_RM_FP_Standard_300...</span>
              <span className="sm:hidden">bidbox.ai</span>
            </h1>
            <div className="w-2 h-2 bg-gray-400 rounded-full hidden sm:block"></div>
          </div>
          
          <div className="flex items-center space-x-2 lg:space-x-4">
            <div className="flex items-center bg-gray-100 rounded-lg p-1">
              <button
                onClick={() => setViewMode('mobile')}
                className={`flex items-center space-x-1 lg:space-x-2 px-2 lg:px-3 py-2 rounded-md text-xs lg:text-sm transition-colors ${
                  viewMode === 'mobile' 
                    ? 'bg-purple-600 text-white' 
                    : 'text-gray-600 hover:bg-gray-200'
                }`}
              >
                <Smartphone size={14} />
                <span className="hidden sm:inline">Mobile</span>
              </button>
              <button
                onClick={() => setViewMode('desktop')}
                className={`flex items-center space-x-1 lg:space-x-2 px-2 lg:px-3 py-2 rounded-md text-xs lg:text-sm transition-colors ${
                  viewMode === 'desktop' 
                    ? 'bg-gray-800 text-white' 
                    : 'text-gray-600 hover:bg-gray-200'
                }`}
              >
                <Monitor size={14} />
                <span className="hidden sm:inline">Desktop</span>
              </button>
            </div>
          </div>
        </div>

        {/* Content Area */}
        <div className="flex-1 flex flex-col lg:flex-row">
          {/* Ad Preview */}
          <div className="flex-1 p-2 lg:p-6">
            {/* Navigation Buttons - Always visible */}
            <div className="flex items-center justify-center space-x-4 lg:space-x-6 mb-4 lg:mb-6">
              <button 
                onClick={prevAd}
                className="flex items-center space-x-1 lg:space-x-2 px-3 lg:px-4 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors text-sm"
              >
                <ChevronLeft size={18} />
                <span className="hidden sm:inline">Prev Ad</span>
                <span className="sm:hidden">Prev</span>
              </button>
              
              <div className="text-xs lg:text-sm text-gray-500 font-medium">
                {adFormats.findIndex(ad => ad.id === selectedAdId) + 1} of {adFormats.length}
              </div>
              
              <button 
                onClick={nextAd}
                className="flex items-center space-x-1 lg:space-x-2 px-3 lg:px-4 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors text-sm"
              >
                <span className="hidden sm:inline">Next Ad</span>
                <span className="sm:hidden">Next</span>
                <ChevronRight size={18} />
              </button>
            </div>

            {/* Ad Container - Mobile Phone Style */}
            <div className="w-full max-w-6xl mx-auto">
              {viewMode === 'mobile' ? (
                // Mobile Phone Mockup
                <div className="max-w-sm mx-auto">
                  <div className="bg-gray-800 rounded-3xl p-2 shadow-2xl">
                    {/* Phone Screen */}
                    <div className="bg-white rounded-2xl overflow-hidden" style={{aspectRatio: '9/19.5'}}>
                      {/* Status Bar */}
                      <div className="bg-white px-4 py-2 flex justify-between items-center text-xs font-semibold">
                        <span>10:59 AM</span>
                        <div className="flex items-center space-x-1">
                          <span className="text-xs">5G</span>
                          <div className="flex space-x-0.5">
                            <div className="w-1 h-3 bg-black rounded-full"></div>
                            <div className="w-1 h-3 bg-black rounded-full"></div>
                            <div className="w-1 h-3 bg-black rounded-full"></div>
                            <div className="w-1 h-2 bg-gray-300 rounded-full"></div>
                          </div>
                          <div className="w-6 h-3 border border-black rounded-sm">
                            <div className="w-4 h-1.5 bg-black rounded-sm m-0.5"></div>
                          </div>
                        </div>
                      </div>
                      
                      {/* App Header */}
                      <div className="bg-white px-4 py-3 border-b border-gray-100 flex items-center justify-between">
                        <div className="text-blue-600 font-bold text-lg">bidbox.ai</div>
                        <div className="w-6 h-6 flex flex-col justify-center space-y-1">
                          <div className="w-full h-0.5 bg-gray-600"></div>
                          <div className="w-full h-0.5 bg-gray-600"></div>
                          <div className="w-full h-0.5 bg-gray-600"></div>
                        </div>
                      </div>

                      {/* Navigation */}
                      <div className="bg-white px-4 py-2 border-b border-gray-100 flex items-center justify-center space-x-4 text-sm text-gray-600">
                        <ChevronLeft size={16} />
                        <span>Prev Ad</span>
                        <span>Next Ad</span>
                        <ChevronRight size={16} />
                      </div>
                      
                      {/* Content Area */}
                      <div className="bg-gray-50 p-4 flex-1">
                        {/* Mock content */}
                        <div className="space-y-3 mb-4">
                          <div className="flex space-x-3">
                            <div className="w-8 h-8 bg-gray-200 rounded"></div>
                            <div className="flex-1 space-y-1">
                              <div className="h-2 bg-gray-200 rounded w-3/4"></div>
                              <div className="h-2 bg-gray-100 rounded w-1/2"></div>
                            </div>
                          </div>
                        </div>

                        {/* Ad Placement */}
                        <div className="bg-white rounded-lg p-2 shadow-sm">
                          <div className="text-xs text-gray-500 text-center mb-2">Advertisement</div>
                          <AdContent />
                        </div>

                        {/* More mock content */}
                        <div className="mt-4 space-y-2">
                          <div className="h-2 bg-gray-200 rounded"></div>
                          <div className="h-2 bg-gray-200 rounded w-4/5"></div>
                        </div>
                      </div>
                      
                      {/* Bottom area */}
                      {/* <div className="bg-white px-4 py-2">
                        <div className="text-xs text-gray-400 text-center">http://localhost:3000</div>
                      </div> */}
                    </div>
                  </div>
                </div>
              ) : (
                // Desktop View
                <div className="bg-white rounded-xl shadow-lg overflow-hidden max-w-4xl mx-auto">
                  <div className="p-8">
                    {/* <div className="space-y-4 mb-6">
                      {Array.from({ length: 3 }).map((_, i) => (
                        <div key={i} className="flex space-x-4">
                          <div className="w-16 h-16 bg-gray-200 rounded-lg flex-shrink-0"></div>
                          <div className="flex-1 space-y-2">
                            <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                            <div className="h-3 bg-gray-100 rounded w-1/2"></div>
                          </div>
                        </div>
                      ))}
                    </div> */}

                    {/* Ad Placement - Highlighted with dashed border */}
                    <div className="border-2 border-dashed border-blue-300 rounded-lg p-4 bg-blue-50/30 mb-6">
                      <div className="text-xs text-blue-600 text-center mb-2 font-medium">Advertisement</div>
                      <AdContent />
                    </div>

                    {/* More mock content */}
                    <div className="space-y-3">
                      {Array.from({ length: 3 }).map((_, i) => (
                        <div key={i} className="h-4 bg-gray-200 rounded w-full"></div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Right Sidebar */}
          <div className="w-80 bg-white border-l border-gray-200 p-6 hidden xl:block">
            <h3 className="text-lg font-semibold text-gray-800 mb-6">Creative Details</h3>
            
            <div className="space-y-6">
              <div className="bg-purple-50 rounded-lg p-4">
                <h4 className="font-medium text-purple-800 mb-3">Ad Info</h4>
                <div className="space-y-2 text-sm">
                  <div>
                    <span className="font-medium text-gray-700">Ad Dimension:</span>
                    <div className="text-gray-600">{currentAd.dimension}</div>
                  </div>
                  <div>
                    <span className="font-medium text-gray-700">Ad Type:</span>
                    <div className="text-gray-600">{currentAd.type}</div>
                  </div>
                  <div>
                    <span className="font-medium text-gray-700">Creative ID:</span>
                    <div className="text-gray-600">{currentAd.creativeId}</div>
                  </div>
                </div>
                <button className="text-blue-500 text-sm hover:underline mt-3">
                  Open Full-Size Creative
                </button>
              </div>

              <div className="flex justify-center">
                <div className="w-32 h-32 border border-gray-300 rounded-lg flex items-center justify-center bg-white">
                  <QrCode size={80} className="text-gray-400" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu Button (shown on mobile) */}
      <div className="lg:hidden fixed bottom-4 right-4">
        <button className="bg-blue-600 text-white p-3 rounded-full shadow-lg">
          <Monitor size={24} />
        </button>
      </div>
    </div>
  );
};

export default MilesDetail ;